module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler hidden-lg-up",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand hidden-md-down",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-md-down"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('header-search-input'), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [(_vm.user.hasPermission('order.add')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.ModalEditOrder",
      modifiers: {
        "ModalEditOrder": true
      }
    }],
    staticClass: "nav-link add-order-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus px-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-down"
  }, [_vm._v("Добавить заказ")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown d-md-down-none show"
  }, [_c('a', {
    staticClass: "nav-link nav-link",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotifications = !_vm.showNotifications
      }
    }
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v(" "), (_vm.paginator.totalCount) ? _c('span', {
    staticClass: "badge badge-pill badge-warning"
  }, [_vm._v(_vm._s(_vm.paginator.totalCount))]) : _vm._e()]), _vm._v(" "), (_vm.showNotifications) ? _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-menu-lg"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [(_vm.paginator.totalCount) ? _c('strong', [_vm._v("У вас " + _vm._s(_vm.paginator.totalCount) + " непрочитанных уведомлений")]) : _c('strong', [_vm._v("У вас нет непрочитанных уведомлений")])]), _vm._v(" "), _c('div', {
    staticClass: "infinity-loading"
  }, [_vm._l((_vm.notifications), function(notification) {
    return _c('a', {
      key: notification.id,
      staticClass: "dropdown-item",
      class: {
        'bg-light-warning': !notification.isViewed
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(notification.objectId)
        }
      }
    }, [_c('i', {
      class: notification.iconClass
    }), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(notification.diffForHumans))]), _vm._v("\n                    " + _vm._s(notification.text) + "\n                ")])
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "notificationsLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('div', {
    staticClass: "mt-1 mb-1"
  }, [_c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем уведомления..."
    }
  })], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("Уведомлений больше нет :)")])])], 2), _vm._v(" "), (_vm.paginator.totalCount) ? _c('div', {
    staticClass: "dropdown-header text-center cursor-pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.markAllAsViewed($event)
      }
    }
  }, [(_vm.loadingMarkAsRead) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('strong', [_vm._v("Отметить все как прочитанные")])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "id": "profile-dropdown",
      "variant": "link"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.getAvatarPath(_vm.user.avatar)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-down"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.user.firstname, 12)))])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-describedby": "profile"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToProfile($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Профиль\n            ")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-describedby": "header1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Выйти")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2328522c"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1010
// module chunks = 1